import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import { AuthState, RootState } from '../../types';
import { GetterTree } from 'vuex';
import { LoginValidationErrors } from './types';
import { LoginData } from '@/models/login';
import {
  atLeastOneNumber,
  atLeastOneLowercase,
  atLeastOneUppercase,
} from '../../validators';
import { UserData } from '@/models/user';

const getters: GetterTree<AuthState, RootState> = {
  isLoggedIn(state: AuthState): boolean {
    return !!state.data.accessToken;
  },
  getToken(state: AuthState): string {
    return state.data.accessToken;
  },
  getLoginData(state: AuthState): LoginData {
    return state.login;
  },
  getNewPassword(state: AuthState): string {
    return state.changePassword.new;
  },
  getConfirmNewPassword(state: AuthState): string {
    return state.changePassword.confirm;
  },
  getUserData(state: AuthState): UserData {
    return state.data.user;
  },
  getUserInitials(state: AuthState): string {
    const name = state.data.user.name;
    const allInitials = (name.match(/\b\w/g) as Array<string>) || [];
    return (
      (allInitials.shift() || '') + (allInitials.pop() || '')
    ).toUpperCase();
  },
  getAuthorization(state: AuthState): string {
    return `${state.data.tokenType} ${state.data.accessToken}`;
  },
  validator(state: AuthState): Vue {
    return new Vue({
      mixins: [validationMixin],
      computed: {
        login: () => state.login,
        changePassword: () => state.changePassword,
      },
      validations: {
        login: {
          email: { required, email },
          password: { required, minLength: minLength(6) },
        },
        changePassword: {
          new: {
            required,
            minLength: minLength(6),
            atLeastOneNumber,
            atLeastOneLowercase,
            atLeastOneUppercase,
          },
          confirm: {
            required,
            sameAs: sameAs(changePassword => changePassword.new),
          },
        },
      },
    });
  },
  getLoginErrors(state: AuthState, getters): LoginValidationErrors {
    const login: LoginValidationErrors = {
      email: [],
      password: [],
    };

    /** Email */
    !getters.validator.$v.login.email.required &&
      login.email.push('Email is required.');

    !getters.validator.$v.login.email.email &&
      login.email.push('Enter with a valid email format.');

    /** Password */
    !getters.validator.$v.login.password.required &&
      login.password.push('Password is required.');

    !getters.validator.$v.login.password.minLength &&
      login.password.push('The password contains at least 6 characters.');

    return login;
  },
};

export default getters;
